import { useEffect } from 'react'
import { createPortal } from 'react-dom'
import { useAppState } from '@/core/state/react'
import { appActions } from '@/core/state/app'

/**
 * App.vue's global <v-snackbar location="top">: shown by appActions.showSnackbar,
 * hidden by its own timeout or by Close. Portalled to <body>, where Vuetify
 * teleported it, so the map's stacking context cannot bury it.
 */
export function Snackbar() {
  const { show, message, color, timeout } = useAppState((s) => s.snackbar)

  useEffect(() => {
    if (!show || timeout <= 0) return
    const id = window.setTimeout(() => appActions.hideSnackbar(), timeout)
    return () => window.clearTimeout(id)
  }, [show, timeout, message])

  if (!show) return null
  return createPortal(
    <div className="scvc-snackbar" data-testid="snackbar" role="status">
      <div className={`scvc-snackbar__wrapper scvc-color--${color}`}>
        <div className="scvc-snackbar__content">{message}</div>
        <div className="scvc-snackbar__actions">
          <button type="button" className="scvc-text-btn" onClick={() => appActions.hideSnackbar()}>
            Close
          </button>
        </div>
      </div>
    </div>,
    document.body,
  )
}
